import { useClassName } from '@/styles/ElementSliderSlide';
import { Component, ComponentProps } from '@/types/component';
import mergeProps from 'lib/utils/mergeProps';
import { SwiperSlide } from 'swiper/react';
import { SlideCaptionComponent } from './Slide.Caption';
import { SlideImageComponent } from './Slide.Image';
import { SlideLinkComponent } from './Slide.Link';

export interface SlideProps extends ComponentProps<typeof SwiperSlide> {}

export const SlideComponent: Component<SlideProps> = ({ children, ...props }) => {
  const className = useClassName('', props);

  return <SwiperSlide {...mergeProps({ className }, props)}>{children}</SwiperSlide>;
};

export const Slide = Object.assign(SlideComponent, {
  Caption: SlideCaptionComponent,
  Image: SlideImageComponent,
  Link: SlideLinkComponent,
});
